
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IConsultationBookingPayloadType } from '../../../types/api/consultation-book-types';


export async function detailUser(id:string): Promise<AxiosResponse<TResponse<IConsultationBookingPayloadType>>> {
    return axios.get(`${API_ENDPOINTS.CONSULTATION_DETAIL}/${id}`)
}


export async function consultationList(qData: QData): Promise<AxiosResponse<TResponseWithQData<IConsultationBookingPayloadType[]>>> {
    return axios.get(API_ENDPOINTS.CONSULTATION_LIST, {
        params: qData
    })
}


export async function updateConsultationStatus(
  data: IConsultationBookingPayloadType
): Promise<AxiosResponse<TResponse<IConsultationBookingPayloadType>>> {
  return axios.put<TResponse<IConsultationBookingPayloadType>>(
    `${API_ENDPOINTS.CONSULTATION_UPDATE}/${data?._id}`,
    data
  );
}


